import { STATUS_STYLES } from "../shared/constants";

export const BACK_LABEL = "Voltar";

export const RELOAD_LABEL = "Recarregar dados";

export const USER_NOT_FOUND_LABEL = "Usuário não encontrado";

export const UNDER_CONSTRUCTION_LABEL =
  "🚧 Esta funcionalidade está em construção...";

export const LOAD_USER_DETAILS_ERROR_MESSAGE =
  "Não foi possível carregar os dados do usuário.";

export const CREATED_AT_PREFIX = "Cadastro em";

export const SCREENINGS_PT_BR_LABEL = "Triagens PT-BR";

export const SCREENINGS_PT_EU_LABEL = "Triagens PT-EU";

export const DETAILS_TABS = {
  purchases: { key: "purchases", label: "Histórico de compras" },
  patients: { key: "patients", label: "Pacientes" },
  logs: { key: "logs", label: "Logs" },
};

export const PURCHASE_HISTORY_TITLE = "Histórico de Compras de Triagens";

export const ADD_SCREENING_LABEL = "Adicionar triagem";

export const EMPTY_PURCHASES_LABEL = "Sem triagens registradas";

export const getPurchaseSummaryText = (purchasedCount, consumedCount) =>
  `${purchasedCount} triagens compradas, ${consumedCount} consumidas.`;

export const USER_LOGS_TITLE = "Logs do usuário";

export const EMPTY_LOGS_LABEL = "Sem logs registrados";

export const LOAD_USER_LOGS_ERROR_MESSAGE =
  "Não foi possível carregar os logs do usuário.";

export const VIEW_PAYLOAD_LABEL = "Ver payload";

export const UPLOAD_DOCUMENT_ACTION = "user_upload_document";

export const PATIENTS_TITLE = "Pacientes";

export const getPatientsSummaryText = (patientsCount) =>
  `${patientsCount} pacientes cadastrados no total`;

export const EMPTY_PATIENTS_LABEL = "Sem pacientes cadastrados";

export const LOAD_USER_PATIENTS_ERROR_MESSAGE =
  "Não foi possível carregar os pacientes do usuário.";

export const VIEW_PATIENT_DETAILS_LABEL = "Ver detalhes do paciente";

export const PATIENT_CREATED_AT_PREFIX = "cadastrado em:";

export const getScreeningsCountText = (screeningsCount) =>
  `Triagens: ${screeningsCount}`;

export const EMPTY_SCREENINGS_LABEL = "Sem triagens registradas";

export const PATIENT_SCREENING_STATUS_CONFIG = {
  started: { label: "Iniciou", style: STATUS_STYLES.gold },
  finished: { label: "Finalizado", style: STATUS_STYLES.green },
  not_started: { label: "Não iniciou", style: STATUS_STYLES.red },
};
